import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftSidePanelProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontLeftSidePanel(props: FrontLeftSidePanelProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Left Side Panel"
      width={326}
      height={48}
      viewBox="0 0 326 48"
      position={{bottom: 0, left: 117}}
    >
      <path
        d="M318 15C298.183 21.5778 293 40.0244 293 46.9996H78L77.7211 46.9973C45.7211 46.9973 4 15.9999 4 15.9999L227 20.9999C237 21 260.6 18 275 2C280.003 3.3286 294.162 3.9689 308 2C309.264 4.8332 314.244 11.0219 325 13C322 14 319.702 14.435 318 15Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M318 15C298.183 21.5778 293 40.0244 293 46.9996H78L77.7211 46.9973C45.7211 46.9973 4 15.9999 4 15.9999L227 20.9999C237 21 260.6 18 275 2C280 3 294 4 308 2C309.264 4.8332 314.244 11.0219 325 13C322 14 319.702 14.435 318 15Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M301 27.4783C264.677 27.7199 236.893 28 217 28C117.543 28 49.2225 24.541 17 20.1739C11 19.1304 9 18.087 4 16"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
